export const PATIENT_INACTIVATION_REASONS = {
  ACCOUNT_ACCOUNT_DEACTIVATED: 'Account - Account deactivated',
  ACCOUNT_DEVICE_TYPE_NOT_MONITORED: 'Account - Device type not monitored',
  BILLING_PROGRAM_COST: 'Billing - Program cost',
  COMPLIANCE_NOT_RESPONSIVE_TO_OUTREACH: 'Compliance - Not responsive to outreach',
  COMPLIANCE_WONT_CONNECT_TO_HOME_MONITOR: "Compliance - Won't connect to home monitor",
  COMPLIANCE_WONT_TRANSMIT: "Compliance - Won't transmit",
  DEVICE_END_OF_SERVICE: 'Device - End of service',
  DEVICE_INCOMPATIBLE_WITH_REMOTE_MONITORING: 'Device - Incompatible with remote monitoring',
  DEVICE_UNABLE_TO_BE_REMOTELY_MONITORED: 'Device - Unable to be remotely monitored',
  DUPLICATE_ALREADY_PATIENT: 'Duplicate - Already Patient',
  ELIGIBILITY_INSURANCE_PLAN_NOT_COVERED: 'Eligibility - Insurance plan not covered',
  ELIGIBILITY_HOSPICE: 'Eligibility - Hospice',
  ELIGIBILITY_CURRENTLY_MONITORED_ELSEWHERE: 'Eligibility - Currently monitored elsewhere',
  ELIGIBILITY_MOVED_LOCATION_NOT_SUPPORTED: 'Eligibility - Moved, location not supported',
  ELIGIBILITY_INCARCERATED: 'Eligibility - Incarcarated',
  ELIGIBILITY_UNABLE_TO_VERIFY_INSURANCE: 'Eligibility - Unable to verify insurance',
  ELIGIBILITY_UNABLE_TO_VERIFY_DEMOGRAPHICS: 'Eligibility - Unable to verify demographics',
  ELIGIBILITY_MOVED_LOCATION: 'Eligibility - Moved location',
  MEDICAL_PHYSICIAN_REQUEST: 'Medical - Physician request',
  MEDICAL_CLINIC_REQUEST: 'Medical - Clinic request',
  MEDICAL_DECEASED: 'Medical - Deceased',
  MEDICAL_EXPLANTED: 'Medical - Explanted',
  MEDICAL_LOST_TO_FOLLOW_UP: 'Medical - Lost to follow up',
  PATIENT_REQUEST_REFUSED_MONITORING: 'Patient Request - Refused monitoring',
  PATIENT_REQUEST_DOESNT_FIND_VALUE_IN_MONITORING:
    "Patient Request - Doesn't find value in monitoring",
  PATIENT_REQUEST_IN_CLINIC_ONLY_MONITORING: 'Patient Request - In Clinic Only Monitoring',
  PATIENT_REQUEST_FOLLOWS_PRN: 'Patient Request - Follows PRN',
  BSC_ADVISORY_ACCOLADE_SMR6: 'BSC Advisory – ACCOLADE SMR6',
  OTHER: 'Other'
} as const;

export type PatientInactivationReason =
  (typeof PATIENT_INACTIVATION_REASONS)[keyof typeof PATIENT_INACTIVATION_REASONS];

export const INACTIVE_STATUS_REASONS = Object.values(PATIENT_INACTIVATION_REASONS);

export const PAUSED_STATUS_REASONS = [
  'Traveling',
  'Hospital',
  'Patient Request',
  'Biotronik – Insufficient Data Window',
  'Other'
];

export const PATIENT_STATUS_OPTIONS = [
  { label: 'Active', value: 'Active' },
  { label: 'Inactive', value: 'Inactive' },
  { label: 'Paused', value: 'Paused' }
];
